import { useLocation } from 'react-router-dom';
import { PAGE_HEADER_SLOT_ID } from '../../lib/pageHeader.jsx';

const TITLES = {
  '/dashboard':     'Dashboard',
  '/map':           'Map',
  '/style-editor':  'Style editor',
  '/datasets':      'Datasets',
  '/api-keys':      'API Keys',
  '/users':         'Users',
  '/settings':      'Settings',
  '/logs':          'Logs'
};

// Layout: page title on the left, a portal slot for page-specific actions
// (see lib/pageHeader.jsx), then the global Connected indicator pinned
// rightmost. Pages inject buttons into the slot via <HeaderActions>.
export default function MainHeader() {
  const { pathname } = useLocation();
  const title = TITLES[pathname] ?? 'MVT ADMS';

  return (
    <header className="flex h-14 items-center justify-between border-b border-ink-100 bg-white px-6">
      <h1 className="text-base font-semibold text-ink-900">{title}</h1>

      <div className="flex items-center gap-3">
        <div id={PAGE_HEADER_SLOT_ID} className="flex items-center gap-2" />

        <div className="flex items-center gap-2 border-l border-ink-100 pl-3 text-sm text-ink-500">
          <i className="fa-duotone fa-circle-check text-emerald-500" />
          <span>Connected</span>
        </div>
      </div>
    </header>
  );
}
